export default theme => ({
  colorError: {
    color: theme.palette.error.A400
  }
});



// WEBPACK FOOTER //
// ./src/atoms/Typography/styles.js